/* eslint-disable */
export default {
  forward: '轉接',
  reply: '回覆',
  ignore: '忽略',
  toVoicemail: '至語音信箱',
  answer: '回答',
  answerAndEnd: '接聽並結束',
  answerAndHold: '接聽並保留',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
